export default __webpack_public_path__ + "static/media/limb_main_small.44ee0940.jpg";